module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Gregory S. Hudson, author and professional photographer, has spent years traveling the world, photographing people, places, and cultures. It is wonderful to explore and listen to people talk about their lives and the history that brings them to where they are today. His first book, "), _c('em', [_vm._v("Through My Eyes")]), _vm._v(", chronicles his travels through photos and famous quotes. Gregory Hudson is the world leading author and creator of Amazon’s book series called Gag Gift Book Series by G Hud. The Gag Gift Book series is a comedy series of dozens of books with bizarre titles. The Gag Gift Books are literally bought and given as gifts because of their titles.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("The people Gregory has met along his journey have been inspirational in bringing this story to light. He now spends half of his time at his Puerto Rico home as well as his home in a pleasant little river town called Ironton, along the Ohio River in Ohio.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("“I wanted this story to be a mixture of true events and fictional events. I believe this blend enhances the story and characters in a way that most people can relate to.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256644c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0